import { IFilter } from '@/shared';

export const jobQueryKeys = {
  savedJobIds: ['saved-job-ids'] as const,
  relatedJobs: {
    get: (jobId: number | string) => ['job', 'relatedJobs', jobId] as const,
  },
  searchJobs: {
    get: (params: IFilter = {}) => ['job', 'searchJobs', params] as const,
  },
  company: (companyId: number) => ['job', 'company', companyId] as const,
  topCountWorks: ['job', 'topCountWorks'] as const,
  activeProfessions: (branchId: number) =>
    ['job', 'activeProfessions', branchId] as const,
  list: {
    get: (params: IFilter = {}) => ['job', 'list', params] as const,
  },
  detail: {
    get: (code: string | number) => ['job', 'detail', code] as const,
  },
  getSavedJobs: {
    all: ['saved-jobs'] as const,
    list: (filters: IFilter = {}) =>
      [...jobQueryKeys.getSavedJobs.all, 'list', filters] as const,
  },
  bannerJobList: ['banner', 'jobList'] as const,
  suggestedJobList: ['auth', 'suggested-job-list'] as const,
  centralJobs: ['central-jobs'] as const,
  autocomplete: (query: string) => ['job', 'autocomplete', query] as const,
  homeSearch: (query: string) => ['job', 'home-search', query] as const,
  skillCompatibility: (jobId: number) =>
    ['job', 'skill-compatibility', jobId] as const,
  jobInsight: (jobId: number) => ['job', 'insight', jobId] as const,
  zangiaPlusReport: ['zangia-plus', 'report'] as const,
} as const;
